define('datakit/util/getobject',[
  'backbone'
], function(Backbone) {
  var getobject = {};

  // Split strings on dot, but only if dot isn't preceded by a backslash. Since
  // JavaScript doesn't support lookbehinds, use a placeholder for "\.", split
  // on dot, then replace the placeholder character with a dot.
  function getParts(str) {
    return str.replace(/\\\./g, '\uffff').split('.').map(function(s) {
      return s.replace(/\uffff/g, '.');
    });
  }

  // Get the value of a deeply-nested property exist in an object.
  getobject.get = function(obj, parts, create) {
    if (typeof parts === 'string') {
      parts = getParts(parts);
    }

    var part, isModel = (obj instanceof Backbone.Model);
    while (typeof obj === 'object' && obj && parts.length) {
      part = parts.shift();
      if (!(isModel ? obj.has(part) : (part in obj)) && create) {
        isModel ? obj.set(part, {}) : obj[part] = {};
      }
      obj = isModel ? obj.get(part) : obj[part];
      isModel = (obj instanceof Backbone.Model);
    }

    return obj;
  };

  // Set a deeply-nested property in an object, creating intermediary objects
  // as we go.
  getobject.set = function(obj, parts, value) {
    parts = getParts(parts);

    var prop = parts.pop(), isModel = false;
    obj = getobject.get(obj, parts, true);
    isModel = (obj instanceof Backbone.Model);
    if (obj && typeof obj === 'object') {
      return isModel ? obj.set(prop, value).get(prop) : (obj[prop] = value);
    }
  };

  // Does a deeply-nested property exist in an object?
  getobject.exists = function(obj, parts) {
    parts = getParts(parts);

    var prop = parts.pop(), isModel = false;
    obj = getobject.get(obj, parts);
    isModel = (obj instanceof Backbone.Model);
    return typeof obj === 'object' && obj && (isModel ? obj.has(prop) : (prop in obj));
  };

  return getobject;
});

